import StoreButtons from './StoreButtons.vue';

export default StoreButtons;
